import plugin from "../../lib/plugin";
import SalesForcePush from "./sales-force-push";
const ELEMENT_SELECTOR = "[data-sales-force-push]";

export function exec() {
    $(() => {
        plugin("salesForcePush", SalesForcePush);
        $(ELEMENT_SELECTOR).salesForcePush();
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sales-force-push/index.js